/**
 * 자체 인스턴트 검색 (Boost ISW 클론).
 *
 * PC(≥990px) — style2: 돋보기 클릭 = 테마 우측 드로어(Most searched products)
 * 그대로. 드로어 입력에 타이핑하면 **드로어는 남긴 채** 결과 패널이 입력에
 * 앵커되어 왼쪽으로 겹쳐 뜬다 (Boost 도 드로어를 닫지 않는다 — 뒤 레이어 유지).
 * 입력·포커스·제출(Enter=/search)은 전부 테마 드로어의 것을 그대로 쓴다.
 *
 *   좌: Collections / Pages (/v1/resources) · 우: Products 2열 (/v1/suggest)
 *   하단: View all N products (N = 검색 매칭 총계, suggest.total_product)
 *   0건 = 현행 문구 + Search tips. 빈 입력 = 패널 숨김(드로어 기본 화면 복귀).
 *
 * 모바일(<990px) — mobile-style1(풀스크린) 실측: 드로어 입력에 타이핑하면
 * 풀스크린 오버레이로 전환 — 상단 64px 바(← 뒤로 + 라운드 필 입력 + ✕),
 * #f8f8f8 시트에 Collections(행) → Products(2열 그리드, 이미지 3:4) →
 * Pages(행) 그룹이 흰 카드로 쌓이고, 하단에 View all 52px 바 고정.
 * ← 뒤로 = 오버레이만 닫고 드로어 복귀(입력값은 양방향 동기화).
 */
(() => {
  const cfgEl = document.querySelector('[data-ts-isw-config]');
  if (!cfgEl) return;
  const CFG = JSON.parse(cfgEl.textContent);
  let API = CFG.apiBase.replace(/\/$/, '');
  // 로컬 theme dev(http)에서 stage 자가서명 인증서 회피 — 검색 위젯과 동일
  if (location.protocol === 'http:' && API.includes('.trenbekr.in')) {
    API = API.replace('https://', 'http://');
  }
  const L = CFG.labels;
  const DESKTOP = () => window.innerWidth >= 990;
  const RECENT_KEY = 'ts:recent-searches';

  const esc = (s) =>
    String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  // 현행 Boost moneyFormat `${{amount}}` + withoutTrailingZeros=true 실측:
  // 'USD' 접미사 없음, $1,439.00 → $1,439 (센트가 있으면 그대로 표시)
  const money = (usd) =>
    `$${Number(usd)
      .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      .replace(/\.00$/, '')}`;

  const recent = {
    add(q) {
      try {
        const list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
        localStorage.setItem(RECENT_KEY, JSON.stringify([q, ...list.filter((x) => x !== q)].slice(0, 3)));
      } catch { /* 프라이빗 모드 등 — 무시 */ }
    },
    list() {
      try {
        const v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
        return Array.isArray(v) ? v.slice(0, 3).filter((x) => typeof x === 'string') : [];
      } catch {
        return [];
      }
    },
  };

  /**
   * 통화앱(bucksCC) 변환 후처리 — 변환 텍스트("₩1,196,066 KRW")에서 통화
   * 코드 접미사를 제거해 현행(Boost) 표시("₩1,196,066")와 맞춘다. USD 등
   * 모든 통화 동일. 변환은 비동기 + 통화 전환 시 재작성되므로 옵저버로
   * 상시 재정규화한다 (정규화 후 텍스트는 다시 매치되지 않아 루프 없음).
   */
  function normalizeMoney(el) {
    const t = el.textContent;
    const n = t.replace(/\s*[A-Z]{3}\s*$/, '').replace(/\.00$/, '');
    if (n && n !== t) {
      el.textContent = n;
      // bucksCC 는 폴링으로 textContent !== bucks-current 면 되돌린다
      // (프리뷰 실측) — 속성도 같이 맞춰 재작성 루프를 끊는다.
      if (el.hasAttribute('bucks-current')) el.setAttribute('bucks-current', n);
    }
  }
  function watchMoney(rootEl) {
    const normalizeAll = () => rootEl.querySelectorAll('.money').forEach(normalizeMoney);
    new MutationObserver(normalizeAll).observe(rootEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    normalizeAll();
  }

  let panel = null; // PC 결과 패널 (드로어 입력에 앵커)
  let anchorInput = null; // 테마 드로어의 검색 입력
  let mob = null; // 모바일 풀스크린 오버레이 {root, input, body, viewall}
  let seq = 0;

  function ensurePanel() {
    if (panel) return;
    panel = document.createElement('div');
    panel.className = 'ts-isw-panel';
    panel.hidden = true;
    document.body.appendChild(panel);
    watchMoney(panel);
    panel.addEventListener('click', (e) => {
      // 최근 검색어 행 클릭: 그 검색어를 저장 목록 맨 앞으로 (링크 이동은 기본 동작)
      const r = e.target.closest('[data-recent-q]');
      if (r) { recent.add(r.getAttribute('data-recent-q')); return; }
      if (e.target.closest('a') && anchorInput?.value.trim()) recent.add(anchorInput.value.trim());
    });
  }

  /** 패널을 드로어 입력 아래·우측 정렬로 앵커 (현행: 드로어 왼쪽으로 확장) */
  function position() {
    if (!anchorInput) return;
    const r = anchorInput.getBoundingClientRect();
    panel.style.top = `${Math.round(r.bottom + 10)}px`;
    panel.style.right = `${Math.max(16, Math.round(window.innerWidth - r.right - 8))}px`;
  }

  function close() {
    if (panel) panel.hidden = true;
  }

  /* ── 모바일 풀스크린 오버레이 ───────────────────────────── */

  function ensureMobile() {
    if (mob) return mob;
    const root = document.createElement('div');
    root.className = 'ts-isw-m';
    root.hidden = true;
    root.innerHTML = `
<div class="ts-isw-m-bar">
  <button type="button" class="ts-isw-m-back" aria-label="Back">
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 11H7.8l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z" fill="currentColor"/></svg>
  </button>
  <form class="ts-isw-m-form" action="${CFG.searchUrl}" method="get" role="search">
    <input class="ts-isw-m-input" type="search" name="q" autocomplete="off" autocapitalize="off" autocorrect="off" placeholder="Search">
    <button type="button" class="ts-isw-m-clear" aria-label="Clear">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.4 17.6 5 12 10.6 6.4 5 5 6.4 10.6 12 5 17.6 6.4 19 12 13.4 17.6 19 19 17.6 13.4 12z" fill="currentColor"/></svg>
    </button>
  </form>
</div>
<div class="ts-isw-m-body"></div>
<a class="ts-isw-m-viewall" href="#" hidden></a>`;
    document.body.appendChild(root);
    const input = root.querySelector('.ts-isw-m-input');
    const body = root.querySelector('.ts-isw-m-body');
    const viewall = root.querySelector('.ts-isw-m-viewall');
    root.querySelector('.ts-isw-m-back').addEventListener('click', closeMobile);
    root.querySelector('.ts-isw-m-clear').addEventListener('click', () => {
      input.value = '';
      syncDrawer('');
      renderRecentMobile(); // 현행: 빈 입력 = Recent searches
      input.focus();
    });
    input.addEventListener('input', () => {
      syncDrawer(input.value);
      queued(input.value.trim());
    });
    root.querySelector('.ts-isw-m-form').addEventListener('submit', () => {
      if (input.value.trim()) recent.add(input.value.trim());
    });
    body.addEventListener('click', (e) => {
      // 최근 검색어 행 클릭: 그 검색어를 다시 저장(맨 앞으로) 후 링크 이동
      const r = e.target.closest('[data-recent-q]');
      if (r) { recent.add(r.getAttribute('data-recent-q')); return; }
      if (e.target.closest('a') && input.value.trim()) recent.add(input.value.trim());
    });
    viewall.addEventListener('click', () => {
      if (input.value.trim()) recent.add(input.value.trim());
    });
    watchMoney(root);
    mob = { root, input, body, viewall };
    return mob;
  }

  /** 드로어 입력과 값 동기화 — ← 뒤로 복귀 시 같은 검색어가 남게.
      프로그램적 value 설정은 input 이벤트를 안 내니 네이티브 predictive 는
      다시 돌지 않는다. */
  function syncDrawer(v) {
    if (anchorInput && anchorInput.value !== v) anchorInput.value = v;
  }

  function openMobile(v) {
    ensureMobile();
    if (anchorInput?.placeholder) mob.input.placeholder = anchorInput.placeholder;
    if (mob.input.value !== v) mob.input.value = v;
    if (!v.trim()) renderRecentMobile(); // 빈 입력으로 열리면 Recent searches
    if (mob.root.hidden) {
      mob.root.hidden = false;
      mob.input.focus();
      try {
        const n = mob.input.value.length;
        mob.input.setSelectionRange(n, n); // 커서를 끝으로 — 이어서 타이핑
      } catch { /* 일부 브라우저의 search 타입 제약 — 무시 */ }
    }
  }

  function closeMobile() {
    if (mob) mob.root.hidden = true;
  }

  const debounce = (fn, ms) => {
    let t;
    return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); };
  };

  /** PC — 빈 입력(포커스 시 포함)이면 입력 아래에 Recent searches 컴팩트
      드롭다운을 앵커한다 (현행 실측, 스크린샷 30 — 드로어는 뒤에 유지).
      저장된 검색어가 없으면 아무것도 띄우지 않는다. */
  function renderRecentDesktop() {
    const items = recent.list();
    if (items.length === 0) { close(); return; }
    ensurePanel();
    panel.classList.add('ts-isw-panel--compact');
    panel.innerHTML = `
<div class="ts-isw-recent">
  <h3 class="ts-isw-recent-heading">${esc(L.recent)}</h3>
  <ul class="ts-isw-links">${items
    .map((q) => `<li><a class="ts-isw-link" data-recent-q="${esc(q)}" href="${CFG.searchUrl}?q=${encodeURIComponent(q)}">${esc(q)}</a></li>`)
    .join('')}</ul>
</div>`;
    position();
    panel.hidden = false;
  }

  async function onQuery(q) {
    const my = ++seq;
    if (!q) {
      // 빈 입력 = Recent searches (현행 실측 — 모바일 스크린샷 29, PC 30)
      if (mob && !mob.root.hidden) { close(); renderRecentMobile(); }
      else if (DESKTOP() && anchorInput) renderRecentDesktop();
      else close();
      return;
    }
    const qs = (extra) => new URLSearchParams({ q, locale: CFG.locale || 'en', ...extra });
    const fetchJson = (url) =>
      fetch(url, { signal: AbortSignal.timeout(5000) }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
    const [sugg, res] = await Promise.all([
      fetchJson(`${API}/v1/suggest?${qs({ limit: '6' })}`),
      // 제목+본문 매칭(기본) — 현행도 완성 검색어는 본문을 매칭한다
      // ('gucci' → Monthly Deals·Brand Size Chart). 1글자 규칙은 백엔드 담당.
      fetchJson(`${API}/v1/resources?${qs({ limit: '3' })}`),
    ]);
    if (my !== seq) return; // 뒤늦은 응답 무시
    if (mob && !mob.root.hidden) renderMobile(q, sugg, res);
    else render(q, sugg, res);
  }

  function render(q, sugg, res) {
    const products = sugg?.products ?? [];
    const total = sugg?.total_product ?? 0;
    const cols = res?.collections?.items?.slice(0, 3) ?? [];
    const pages = res?.pages?.items?.slice(0, 3) ?? [];
    ensurePanel();

    panel.classList.remove('ts-isw-panel--compact');
    if (products.length === 0 && cols.length === 0 && pages.length === 0) {
      panel.innerHTML = `
<div class="ts-isw-empty">
  <p class="ts-isw-empty-msg">${esc(L.empty.replace('TERMS', q))}</p>
  <h3 class="ts-isw-heading">${esc(L.tipsTitle)}</h3>
  <ul class="ts-isw-tips">${L.tips.map((t) => `<li>${esc(t)}</li>`).join('')}</ul>
</div>`;
    } else {
      const linkGroup = (label, items) =>
        items.length === 0
          ? ''
          : `<h3 class="ts-isw-heading">${esc(label)}</h3>
<ul class="ts-isw-links">${items.map((i) => `<li><a class="ts-isw-link" href="${esc(i.url)}">${esc(i.title)}</a></li>`).join('')}</ul>`;
      // Collections·Pages 둘 다 없으면 좌측 컬럼을 아예 렌더하지 않는다
      // (현행 no-other: 상품이 패널 풀폭). CSS :empty 는 템플릿 공백
      // 텍스트 노드 때문에 안 걸린다 — 프리뷰 실측.
      const side = `${linkGroup(L.collections, cols)}${linkGroup(L.pages, pages)}`;
      panel.innerHTML = `
<div class="ts-isw-body">
  ${side ? `<div class="ts-isw-side">${side}</div>` : ''}
  <div class="ts-isw-main">
    ${products.length ? `<h3 class="ts-isw-heading">${esc(L.products)}</h3>
    <ul class="ts-isw-products">${products.map(productHtml).join('')}</ul>` : ''}
    ${total > 0 ? `<a class="ts-isw-viewall" href="${CFG.searchUrl}?q=${encodeURIComponent(q)}">${esc(L.viewAll.replace('COUNT', total.toLocaleString('en-US')))} <span aria-hidden="true">→</span></a>` : ''}
  </div>
</div>`;
    }
    position();
    panel.hidden = false;
    window.bucksCC?.reConvert?.(); // 통화앱 KRW 변환
  }

  /** 세일 여부 + 가격 마크업 — PC·모바일 카드 공용.
      compare_at_price 는 {usd,krw} 객체 — usd 로 비교 (숫자 비교 버그 수정) */
  function priceParts(p) {
    const cmp = p.compare_at_price?.usd;
    const onSale = (cmp && cmp > p.price.usd) || p.discount_rate > 0;
    // 취소선은 <s> 가 아닌 span+CSS — 통화앱(bucksCC)이 <s>.money 는 KRW 로
    // 변환하지 않는다 (프리뷰 실측). Boost 도 span + line-through 를 쓴다.
    const price = onSale
      ? `<span class="ts-isw-price-sale money">${money(p.price.usd)}</span>${cmp ? ` <span class="ts-isw-price-compare money">${money(cmp)}</span>` : ''}`
      : `<span class="money">${money(p.price.usd)}</span>`;
    return { onSale, price };
  }

  function productHtml(p) {
    const img = p.image ? `${p.image}${p.image.includes('?') ? '&' : '?'}width=200` : '';
    const { onSale, price } = priceParts(p);
    return `
<li class="ts-isw-product">
  <a href="${esc(p.url || `/products/${p.handle}`)}">
    <span class="ts-isw-product-media">${onSale ? '<span class="ts-isw-badge">SALE</span>' : ''}${img ? `<img src="${esc(img)}" alt="" loading="lazy">` : ''}</span>
    <span class="ts-isw-product-info">
      <span class="ts-isw-product-title">${esc(p.title)}</span>
      <span class="ts-isw-product-vendor">${esc(p.brand)}</span>
      <span class="ts-isw-product-price">${price}</span>
    </span>
  </a>
</li>`;
  }

  /* ── 모바일 렌더 (mobile-style1 실측: 그룹별 흰 카드 + 2열 그리드) ── */

  function mobileProductHtml(p) {
    const img = p.image ? `${p.image}${p.image.includes('?') ? '&' : '?'}width=400` : '';
    const { onSale, price } = priceParts(p);
    return `
<li class="ts-isw-mp">
  <a href="${esc(p.url || `/products/${p.handle}`)}">
    <span class="ts-isw-mp-media">${onSale ? '<span class="ts-isw-badge">SALE</span>' : ''}${img ? `<img src="${esc(img)}" alt="" loading="lazy">` : ''}</span>
    <span class="ts-isw-mp-title">${esc(p.title)}</span>
    <span class="ts-isw-mp-vendor">${esc(p.brand)}</span>
    <span class="ts-isw-mp-price">${price}</span>
  </a>
</li>`;
  }

  /** 빈 입력 상태 — 현행처럼 Recent searches 그룹(최대 3개)을 보여준다.
      행은 /search?q= 링크: 클릭 시 그 검색어로 검색 (+ 저장 목록 맨 앞으로).
      저장된 검색어가 없으면 현행과 동일하게 빈 시트. */
  function renderRecentMobile() {
    const items = recent.list();
    mob.viewall.hidden = true;
    mob.body.innerHTML =
      items.length === 0
        ? ''
        : `<div class="ts-isw-m-group">
  <h3 class="ts-isw-m-heading">${esc(L.recent)}</h3>
  <ul class="ts-isw-m-list">${items
    .map((q) => `<li><a class="ts-isw-m-link" data-recent-q="${esc(q)}" href="${CFG.searchUrl}?q=${encodeURIComponent(q)}">${esc(q)}</a></li>`)
    .join('')}</ul>
</div>`;
  }

  function renderMobile(q, sugg, res) {
    const products = sugg?.products ?? [];
    const total = sugg?.total_product ?? 0;
    const cols = res?.collections?.items?.slice(0, 3) ?? [];
    const pages = res?.pages?.items?.slice(0, 3) ?? [];

    const rows = (label, items) =>
      items.length === 0
        ? ''
        : `<div class="ts-isw-m-group">
  <h3 class="ts-isw-m-heading">${esc(label)}</h3>
  <ul class="ts-isw-m-list">${items.map((i) => `<li><a class="ts-isw-m-link" href="${esc(i.url)}">${esc(i.title)}</a></li>`).join('')}</ul>
</div>`;

    if (products.length === 0 && cols.length === 0 && pages.length === 0) {
      mob.body.innerHTML = `
<div class="ts-isw-m-group ts-isw-m-card">
  <div class="ts-isw-empty">
    <p class="ts-isw-empty-msg">${esc(L.empty.replace('TERMS', q))}</p>
    <h3 class="ts-isw-heading">${esc(L.tipsTitle)}</h3>
    <ul class="ts-isw-tips">${L.tips.map((t) => `<li>${esc(t)}</li>`).join('')}</ul>
  </div>
</div>`;
      mob.viewall.hidden = true;
    } else {
      // 현행 모바일 실측 순서: Collections → Products → Pages
      mob.body.innerHTML = `
${rows(L.collections, cols)}
${products.length ? `<div class="ts-isw-m-group">
  <h3 class="ts-isw-m-heading">${esc(L.products)}</h3>
  <ul class="ts-isw-m-products">${products.map(mobileProductHtml).join('')}</ul>
</div>` : ''}
${rows(L.pages, pages)}`;
      if (total > 0) {
        mob.viewall.href = `${CFG.searchUrl}?q=${encodeURIComponent(q)}`;
        mob.viewall.innerHTML = `${esc(L.viewAll.replace('COUNT', total.toLocaleString('en-US')))} <span aria-hidden="true">→</span>`;
        mob.viewall.hidden = false;
      } else {
        mob.viewall.hidden = true;
      }
    }
    window.bucksCC?.reConvert?.(); // 통화앱 KRW 변환
  }

  const queued = debounce((q) => onQuery(q), 300);

  // PC: 드로어 입력에 포커스(드로어 열림 직후 포함) + 빈 입력 → Recent searches.
  // 드로어를 여는 클릭이 document 까지 버블돼 "바깥 클릭 닫기"에 걸리므로,
  // 그 클릭이 끝난 뒤(태스크 큐)로 렌더를 미룬다 (프리뷰 실측).
  document.addEventListener('focusin', (e) => {
    const el = e.target;
    if (!(el instanceof HTMLInputElement)) return;
    if (!el.classList.contains('f-search-drawer__input')) return;
    if (!DESKTOP() || el.value.trim()) return;
    anchorInput = el;
    setTimeout(() => {
      if (document.activeElement === el && !el.value.trim() && DESKTOP()) renderRecentDesktop();
    }, 0);
  });

  // 드로어 입력에 타이핑 → PC: 앵커 패널 / 모바일: 풀스크린 오버레이로 이관
  document.addEventListener(
    'input',
    (e) => {
      const el = e.target;
      if (!(el instanceof HTMLInputElement)) return;
      if (!el.classList.contains('f-search-drawer__input')) return;
      anchorInput = el;
      if (!DESKTOP()) openMobile(el.value); // 이후 타이핑은 오버레이 입력이 받는다
      queued(el.value.trim());
    },
    true,
  );

  // 제출(Enter → /search) 시 최근 검색어 저장
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target.closest?.('.f-search-drawer__form');
      if (form && anchorInput?.value.trim()) recent.add(anchorInput.value.trim());
    },
    true,
  );

  // 닫기: 드로어 닫힘(X·오버레이), ESC, 패널·드로어 밖 클릭, 모바일 전환
  document.addEventListener('click', (e) => {
    // 이미 포커스된 빈 입력을 다시 클릭 → focusin 이 없으므로 여기서 연다
    const el = e.target;
    if (
      el instanceof HTMLInputElement &&
      el.classList.contains('f-search-drawer__input') &&
      DESKTOP() && !el.value.trim()
    ) {
      anchorInput = el;
      renderRecentDesktop();
      return;
    }
    if (!panel || panel.hidden) return;
    if (e.target.closest('.f-drawer__close') || e.target.closest('.f-drawer__overlay')) { close(); return; }
    if (!panel.contains(e.target) && !e.target.closest('#Drawer-Search')) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { close(); closeMobile(); }
  });
  window.addEventListener('resize', () => {
    if (!DESKTOP()) close();
    else {
      closeMobile();
      if (panel && !panel.hidden) position();
    }
  });
})();
